import { createStore } from 'vuex'
export default createStore({
  state: {
    name:'首页'
  },
  getters: {
  },
  mutations: {
    setName(state,name){
         state.name=name
         console.log(name,'store')
    }
  },
  actions: {
    acname(context,name){
        context.commit('setName',name)
    }
  },
  modules: {
  }
})
